<template>
  <div class="board_paging">
    <button type="button" class="page_num" v-if="toPage.pageNow != 1" v-on:click="onSubmit(toPage.pageNow - 1)">이전</button>
    <div class="page_num">
      <span class="blind">
        <a href="javascript:;" v-on:click="onSubmit(idx)" class="page_btn" v-for="idx in toPage.pageNum" :key="idx" v-bind:class="{ active: toPage.pageNow === idx }">{{ idx }}</a>
      </span>
    </div>
    <button type="button" class="page_num" v-if="toPage.pageNow < toPage.pageNum" v-on:click="onSubmit(toPage.pageNow + 1)">다음</button>
  </div>
</template>

<script>
export default {
  props: {
    toPage: {
      type: Object,
    },
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    onSubmit(e) {
      this.$emit('pageClick', e)
    },
  },
}
</script>

<style>
.board_paging {
  display: flex;
  margin-top: 10px;
  justify-content: center;
  margin: 10px 20px;
}
.page_num {
  color: #000;
  font-size: 15px;
  border: none;
  padding: 8px;
}

.page_num .blind {
  color: #000;
  font-size: 15px;
}
.page_btn {
  color: #000;
  font-size: 15px;
  padding: 4px 9px;
  cursor: pointer;
  text-decoration: none;
}
.page_btn.active {
  border: rgba(0, 0, 0, 0.226) solid 2px;
}
.page_btn:hover {
  color: #000;
}
</style>
